// extracted by mini-css-extract-plugin
export default {"info":"AboutEducation_info__7sgeL","school_grid":"AboutEducation_school_grid__b+Y1I","level":"AboutEducation_level__ps5Hg","level__info":"AboutEducation_level__info__ou3VY"};